(function () {

  'use strict';

  function pxOktaForm(IdpProviderService, RegexModel, toastr, $filter) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/authenticationSettings/okta/oktaForm/oktaForm.template.html',
      link: function (scope) {
        scope.descriptor = IdpProviderService.descriptorByType('okta');

        const domainRegex = new RegexModel().domainRegex_v3();

        scope.idProvider = {
          domain: null,
          client_id: null,
          client_secret: null,
          authorization_server: null
        };

        scope.idProviderInvalid = true;

        scope.testForm = function () {
          const required = {
            domain: verifyDomain(),
            client_id: verifyClient_id(),
            client_secret: verifyClient_secret()
          };

          scope.domain = {
            valid: verifyDomain()
          };

          const requirementsFulfilled = Object.values(required).every(function (value) {
            return value === true;
          });

          scope.idProviderInvalid = !requirementsFulfilled;
        };

        function verifyDomain() {
          return domainRegex.test(scope.idProvider.domain);
        }

        function verifyClient_id() {
          return scope.idProvider.client_id ? true : false;
        }

        function verifyClient_secret() {
          return scope.idProvider.client_secret ? true : false;
        }

        scope.submit = function () {
          IdpProviderService.create(scope.tenant, 'okta', scope.idProvider).then(function () {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function (error) {
            IdpProviderService.handleCreateError(error, scope.descriptor, scope.tenant);
          });
          scope.callback();
        };
      }
    };
  }

  pxOktaForm.$inject = ['IdpProviderService', 'RegexModel', 'toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxOktaForm', pxOktaForm);

})();
